import { render, staticRenderFns } from "./OfflineNotificationComponent.vue?vue&type=template&id=38dbfa36&scoped=true"
import script from "./OfflineNotificationComponent.vue?vue&type=script&lang=js"
export * from "./OfflineNotificationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.7.4_webpack@5.102.1__ejs@3.1.1_8e3b2d983739573c8a37493d5fe535f8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbfa36",
  null
  
)

export default component.exports